import {
   ADD_ACCOUNT,
   DELETE_ACCOUNT,
   GET_ACCOUNT,
   GET_ACCOUNTS,
   GET_ACCOUNTS_FOR_REPORT,
   GET_ACCOUNTS_FOR_CASH_BANK,
   GET_ACCOUNTS_FOR_MASTER,
   UPDATE_ACCOUNT,
   EMPTY_ACCOUNT,
   GET_ACCOUNT_BROKER,
   GET_SUSPENSE_ACCOUNTS,
   GET_ACCOUNTS_FOR_DASHBOARD,
} from '../types';

// const initialState = { list: [], single: null };
const initialState = {
   list: [],
   suspense_list: [],
   pagination: {
      limit: 10,
      nextPage: null,
      totalPages: 1,
      currentPage: 1,
      hasNextPage: false,
      previousPage: null,
      totalProducts: 0,
      hasPreviousPage: false,
   },
   single: null,
   broker: null,
};

const reducer = (state = initialState, action) => {
   const { type, payload } = action;

   switch (type) {
      case GET_ACCOUNTS:
         return { ...state, list: payload.data, pagination: payload.pagination };
      case GET_ACCOUNTS_FOR_REPORT:
         return { ...state, listForReport: payload.data, paginationForReport: payload.pagination };
      case GET_ACCOUNTS_FOR_CASH_BANK:
         return { ...state, listForCashBank: payload.data, paginationForCashBank: payload.pagination };
      case GET_ACCOUNTS_FOR_MASTER:
         return { ...state, listForMaster: payload.data, paginationForMaster: payload.pagination };
      case GET_SUSPENSE_ACCOUNTS:
         return { ...state, suspense_list: payload.data, pagination: payload.pagination };
      case GET_ACCOUNT:
         return { ...state, single: payload || initialState.single };

      case GET_ACCOUNT_BROKER:
         return { ...state, broker: payload || initialState.single };

      case EMPTY_ACCOUNT:
         return { ...state, single: payload, broker: payload };

      case UPDATE_ACCOUNT:
         return {
            ...state,
            list: state.list.map((item) => (item.id === payload.id ? payload : item)),
         };

      case ADD_ACCOUNT:
         return {
            ...state,
            list: [payload, ...state.list],
         };

      case DELETE_ACCOUNT:
         return {
            ...state,
            list: state.list.filter((item) => item.id !== payload.id),
         };

      case GET_ACCOUNTS_FOR_DASHBOARD:
         return { ...state, dashboardAccounts: payload.data };

      default:
         return state;
   }
};

export default reducer;
